export default __webpack_public_path__ + "static/photon_einstein_blink-03c9ba52b100db4384020b183674501a.svg";